import { Col, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import Button from '../Button';
import { RESOURCES_ROUTE } from '../../routes/types';
import { useNavigate } from 'react-router-dom';

export type UploadSuccessModalProps = {
  showModal: boolean;
  handleClose: () => void;
  successMessage: JSX.Element;
};

const UploadSuccessModal = ({
  showModal,
  handleClose,
  successMessage,
}: UploadSuccessModalProps) => {
  const navigate = useNavigate();
  return (
    <>
      <Modal
        show={showModal}
        onHide={handleClose}
        size={'lg'}
        className={'my-auto'}
      >
        <Modal.Header className={'border-0'} closeButton>
          <Modal.Title className={' ms-auto h6 fw-normal'}>
            Success!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="justify-content-center px-13 mx-3 px-lg-0 mx-lg-0">
            <Col className="d-flex justify-content-center col-10 col-sm-10 col-lg-9">
              <img
                className="img-fluid w-100"
                src={`${process.env.PUBLIC_URL}/${'upload-success.png'}`}
                alt="alarm"
              />
            </Col>
          </Row>
          <Row>
            <Col className="d-flex justify-content-center my-11 pt-5 ">
              {successMessage}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className={'pt-1'}>
          <Button variant={'primary-outline'} onMouseDown={handleClose}>
            Close
          </Button>
          <Button
            variant={'primary'}
            onMouseDown={() => {
              navigate(`${RESOURCES_ROUTE}/documents`);
              handleClose();
            }}
            className="mb-7 mb-lg-0"
          >
            Document Center
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UploadSuccessModal;
